<template>
	<div class="omapi-card-setting-section omapi-integration-settings">
		<header>
			<h3>
				Default Integration
			</h3>
		</header>
		<div class="omapi-integration-settings__options">
			<div>
				<common-selectable-input
					type="checkbox"
					:value="showDefaultIntegration ? '1' : '0'"
					:checked="showDefaultIntegration"
					@input="showDefaultIntegration = ! showDefaultIntegration"
				>
					Set the default integration to be used for campaigns associated with this site?
				</common-selectable-input>
			</div>
			<div v-if="showDefaultIntegration" class="omapi-integration-settings__defaults">
				<div class="omapi-integration-settings__defaults-provider">
					<common-tooltip
						tooltip="Select your default marketing integration provider for new campaigns."
					>
						<label>Provider:</label>
					</common-tooltip>

					<core-form-fancy-select-input
						v-model="provider"
						:options="providersOptions"
						placeholder="Select a Provider..."
						searchPlaceholder="Type to search for an integration provider..."
					/>
				</div>
				<div class="omapi-integration-settings__defaults-account">
					<common-tooltip
						tooltip="Select your default marketing integration provider connection for new campaigns."
					>
						<label>Account Selection:</label>
					</common-tooltip>

					<core-form-fancy-select-input
						name="defaultIntegration"
						:value="defaultIntegration"
						@input="sendEvent"

						:options="integrationAccounts"
						:placeholder="integrationAccountsPlaceholder"
						searchPlaceholder="Type to search for an integration..."
						:showNoOptions="true"
					>
						<template v-slot:noOptions>{{ integrationAccountsPlaceholder }}</template>
					</core-form-fancy-select-input>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
import { mapState, mapGetters } from 'vuex'

export default  {
	props : {
		defaultIntegration : {
			type     : String,
			required : true,
		},
	},
	data () {
		return {
			showDefaultIntegration : false,
			provider               : '',
		}
	},
	mounted () {
		if (this.defaultIntegrationProvider) {
			this.provider = this.defaultIntegrationProvider
		}

		if (this.defaultIntegration) {
			this.showDefaultIntegration = true
		}
	},
	watch : {
		defaultIntegrationProvider (newValue) {
			this.provider = newValue
		},
		defaultIntegration (newValue) {
			if (newValue) {
				this.showDefaultIntegration = true
			}
		},
		showDefaultIntegration (newVal) {
			this.$emit('toggle', newVal)
		},
	},
	computed : {
		...mapState('settings', [
			'providers',
			'integrations',
		]),
		...mapGetters('settings', [
			'hasDefaultIntegration',
			'defaultIntegrationProvider',
			'providerIntegrations',
		]),
		providersOptions () {
			return this.providers.map((o) => ({
				name  : o.name,
				value : o.id,
			}))
		},
		integrationAccounts () {
			if (!this.provider) {
				return []
			}

			const slug = this.$get('provider.value', this.provider)
			return this.providerIntegrations(slug).map(i => ({
				name  : i.name,
				value : i.id,
			}))
		},
		integrationAccountsPlaceholder () {
			if (!this.provider) {
				return 'Select a provider first...'
			}

			return this.integrationAccounts.length ? 'Select an Integration...' : 'No accounts found...'
		},
	},
	methods : {
		sendEvent (selected, attrs) {
			this.$emit('input', selected, attrs)
		},
	},
}
</script>
<style lang="scss">
	.omapi-integration-settings__defaults {
		position: relative;

		// What is this before pseudo-element nonsense?? Well let me tell you.
		//
		// When the default integration settings are _visible_, it's super easy
		// to accidentally click on the checkbox label above it, which then
		// toggles the settings closed. This before element simply applies a
		// layer that covers _most_ of the label text so that clicking it
		// _while the settings are visible_ will not cause it to uncheck/close.
		//
		// It's a total hack, but should prevent some weird frustrations.
		//
		// Also of note, I left _some_ of the label text still clickable (on the
		// left) as I didn't want to completely obliterate the a11y-helpfulness
		// of a  clickable label. ¯\_(ツ)_/¯
		//
		&:before {
			content: '';
			width: 100%;
			height: 100px;
			position: absolute;
			top: -25px;
			left: 90px;
		}

		&-account {
			z-index: 1;
		}
	}
</style>
